import { AuthContext } from '@forto-dev/frontend-infra-auth'
import { ReactQueryClientProvider } from '@forto-dev/frontend-infra-reactquery'
import type { ActivityFeedConfig, ActivityFeedV2RootProps } from '@forto-dev/insights'
import {
  ActivityFeedContainer,
  ActivityFeedContent,
  ActivityFeedContextWrapper,
  ActivityFeedFilterSection,
  ActivityFeedMessageBox,
} from '@forto-dev/insights'
import { config } from 'app/config'
import { FC } from 'react'
import { useAuth } from 'service/useAuth'
import { LocalisationContext, useI18n } from 'utils/localisation'
import { ErrorBoundary } from 'view/ErrorBoundary'

export const ActivityFeedV2: FC<Pick<ActivityFeedV2RootProps, 'entities'>> = ({ entities }) => {
  const store = useI18n()
  const authStore = useAuth()
  const isForCustomer = entities[0]?.type === 'customer'

  const requiredConfig: ActivityFeedConfig = {
    APP_ENV: config.APP_ENV,
    DOCUMENTS_CORE_V2_ENDPOINT: config.DOCUMENTS_CORE_V2_ENDPOINT,
    FEED_CORE_V2_ENDPOINT: config.FEED_CORE_V2_ENDPOINT,
    SHIPPING_ENDPOINT: config.SHIPPING_ENDPOINT,
    WEBSOCKET_ENDPOINT: config.WEBSOCKET_ENDPOINT,
    SUBSCRIPTIONS_ENDPOINT: config.SUBSCRIPTIONS_ENDPOINT,
    NOTIFICATION_CENTER_ENDPOINT: config.NOTIFICATION_CENTER_ENDPOINT,
    USER_SERVICE_ENDPOINT: config.USER_SERVICE_ENDPOINT,
    ANALYTICS_ID: config.FULLSTORY_ANALYTICS_ID,
  }

  const props: ActivityFeedV2RootProps = { entities, config: requiredConfig, isInternal: false }

  return (
    <ErrorBoundary handleReactCatch={(e) => console.error("Couldn't load AF V2", e)}>
      <LocalisationContext.Provider value={store}>
        <AuthContext.Provider value={authStore}>
          <ReactQueryClientProvider>
            <ActivityFeedContextWrapper entities={props.entities} config={props.config} isInternal={props.isInternal}>
              <ActivityFeedContainer>
                {!isForCustomer && <ActivityFeedMessageBox uploadDocumentButton={props.uploadDocumentButton} />}
                <ActivityFeedFilterSection />
                <ActivityFeedContent />
              </ActivityFeedContainer>
            </ActivityFeedContextWrapper>
          </ReactQueryClientProvider>
        </AuthContext.Provider>
      </LocalisationContext.Provider>
    </ErrorBoundary>
  )
}
